import { EMPTY } from 'rxjs';
import {
  RegisterExtensionEditorSetup,
  RegisterExtensionRender,
} from '../../types/registerExtension';
import { Editor, EditorOptions } from 'tinymce';
import { chatbubbleEllipsesOutline } from 'ionicons/icons';
import { TranslateService } from '@ngx-translate/core';
import { Injector } from '@angular/core';

const speechExtensionRender: RegisterExtensionRender = () => EMPTY;

const speechExtensionEditorSetup: RegisterExtensionEditorSetup = (
  editor: Editor,
  injector: Injector
) => {
  const translate = injector.get(TranslateService);
  editor.ui.registry.addIcon(
    'speech',
    chatbubbleEllipsesOutline.slice(chatbubbleEllipsesOutline.indexOf(',') + 1)
  );
  editor.ui.registry.addToggleButton('speech', {
    icon: 'speech',
    tooltip: translate.instant('chat.format.speech'),
    onAction: () => {
      editor.formatter.toggle('speechFormat');
    },
    onSetup: (api) => {
      const sync = () => api.setActive(editor.formatter.match('speechFormat'));
      editor.on('NodeChange', sync);
      return () => editor.off('NodeChange', sync);
    },
  });
};

const speechExtensionEditorFormat: EditorOptions['formats'] = {
  speechFormat: {
    block: 'div',
    classes: 're-speech',
    attributes: { 'data-speech': 'true' },
    wrapper: true,
  },
};

export const speechExtension = {
  render: speechExtensionRender,
  setup: speechExtensionEditorSetup,
  format: speechExtensionEditorFormat,
};
